module.exports = __webpack_public_path__ + "img/106.6f35def2.jpg";